import { render, staticRenderFns } from "./AdminFirstPage.vue?vue&type=template&id=c85d1308&scoped=true&"
import script from "./AdminFirstPage.vue?vue&type=script&lang=js&"
export * from "./AdminFirstPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminFirstPage.vue?vue&type=style&index=0&id=c85d1308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85d1308",
  null
  
)

export default component.exports